export function SimpleBunkerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 19"
      width="31"
      height="19"
      fill="none"
    >
      <g clipPath="url(#clip0_239_2863)">
        <mask id="path-1-inside-1_239_2863" fill="white">
          <path d="M0 0H8V10H0V0Z" />
        </mask>
        <path d="M0 0H8V10H0V0Z" fill="currentColor" />
        <path
          d="M8 8H0V12H8V8Z"
          fill="currentColor"
          mask="url(#path-1-inside-1_239_2863)"
        />
        <mask id="path-3-inside-2_239_2863" fill="white">
          <path d="M9 0H16V10H9V0Z" />
        </mask>
        <path d="M9 0H16V10H9V0Z" fill="currentColor" />
        <path
          d="M16 8H9V12H16V8Z"
          fill="currentColor"
          mask="url(#path-3-inside-2_239_2863)"
        />
        <mask id="path-5-inside-3_239_2863" fill="white">
          <path d="M17 0H25V10H17V0Z" />
        </mask>
        <path d="M17 0H25V10H17V0Z" fill="currentColor" />
        <path
          d="M25 8H17V12H25V8Z"
          fill="currentColor"
          mask="url(#path-5-inside-3_239_2863)"
        />
        <rect x="2" y="11" width="21" height="5" fill="currentColor" />
        <circle cx="8" cy="16" r="2.5" fill="currentColor" stroke="#EEF2FD" />
        <circle cx="17" cy="16" r="2.5" fill="currentColor" stroke="#EEF2FD" />
        <rect x="24" y="12" width="8" height="3" fill="currentColor" />
        <line x1="8.74228e-08" y1="9" x2="25" y2="9" stroke="#DFE6FA" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_239_2863">
          <rect width="31" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
